import React from "react";
import LmsTable from "../ui/LmsTable";
import { useParseRouteActions, useFetchData, getIsGreaterThanTablet, useForm } from "../../../helpers/GlobalHelper";
import LmsFormGenerator, { BCFormController, getInitialValues } from "../ui/LmsFormGenerator";
import BCDashboard from "../../ui/BCDashboard";
import { Button } from "semantic-ui-react";
import { GlobalConstants } from "../../constants/GlobalConstants";
import { FeatureFlags } from "../../constants/LocalServerConstants";

const MainTable = () => {
  const actionsButtons = ["edit", "export"];

  return <LmsTable
    actionButtons={actionsButtons}
    apiSuffix="" // TODO: Add table suffix
    sortable={["Created On"]}
  />;
};

const EditForm = ({ id }) => {
  if (FeatureFlags.IS_DEBUG) {
    console.log(id);
  }

  const [{ data = {}, isLoading }] = useFetchData(`${id}`);
  const myForm = new BCFormController(data, { submitSuffix: "", blankWidth: 1, noBorder: true }); // TODO: Add submit suffix
  myForm.addCenteredGroup([myForm.getDropdownField("Borrower", "")]);
  myForm.addCenteredGroup([myForm.getDropdownField("Special Purpose Entity", "")]);
  myForm.addCenteredGroup([myForm.getDropdownField("Loan Program", "")]);
  myForm.addCenteredGroup([myForm.getDropdownField("Loan Sub Type", "")]);
  myForm.addCenteredGroup([myForm.getDropdownField("Property Type", "")]);
  myForm.addCenteredGroup([myForm.getInputField("Estimated Construction Budget")]);
  myForm.addCenteredGroup([myForm.getInputField("Additional Mortgage")]);
  myForm.addCenteredGroup([myForm.getDropdownField("Loan Officer", "")]);
  myForm.addCenteredGroup([myForm.getDropdownField("Loan Contact", "")]);

  const myForm1 = new BCFormController(data, { submitSuffix: "", blankWidth: 1, initIsDisabled: true, noBorder: true }); // TODO: Add submit suffix
  myForm1.addCenteredGroup([
    myForm1.getInputField("Loan Program"),
    myForm1.getInputField("Builders Name"),
  ]);
  myForm1.addCenteredGroup([
    myForm1.getInputField("Project Name"),
    myForm1.getInputField("Lot Number"),
  ]);
  myForm1.addCenteredGroup([
    myForm1.getInputField("Property Address"),
    myForm1.getDropdownField("Property City"),
  ]);
  myForm1.addCenteredGroup([
    myForm1.getDropdownField("Property State"),
    myForm1.getDropdownField("Property Zip Code"),
  ]);
  myForm1.addCenteredGroup([
    myForm1.getInputField("Parcel Info"),
    myForm1.getCurrencyField("Loan Amount"),
  ]);
  myForm1.addCenteredGroup([
    myForm1.getCurrencyField("Rehab Budget"),
    myForm1.getNumberField("Loan Term"),
  ]);
  myForm1.addCenteredGroup([
    myForm1.getCurrencyField("Property Value"),
    myForm1.getInputField("Property Status"),
  ]);
  myForm1.addCenteredGroup([
    myForm1.getInputField("Construction Type"),
    myForm1.getNumberField("No Of Units"),
  ]);
  myForm1.addCenteredGroup([
    myForm1.getNumberField("No Of Parcels"),
    myForm1.getInputField("Permit Status"),
  ]);
  myForm1.addCenteredGroup([
    myForm1.getInputField("Build Time Frame"),
    myForm1.getInputField("Sell Time Frame"),
  ]);
  myForm1.addCenteredGroup([
    myForm1.getInputField("Pay Off Strategy"),
    myForm1.getInputField("Sell No Of Units"),
  ]);
  myForm1.addCenteredGroup([
    myForm1.getInputField("Work Status"),
    myForm1.getCalendarField("Closing Date"),
  ]);

  const useFormInstance = useForm(getInitialValues([myForm, myForm1]));
  const handleSave = () => {
    if (FeatureFlags.IS_DEBUG) {
      console.log(useFormInstance); // TODO: Handle Save Call
    }
  };

  const handleApprove = () => {
    if (FeatureFlags.IS_DEBUG) {
      console.log(useFormInstance); // TODO: Handle Approve Call
    }
  };

  const LMSLoansLayout = [
    [
      {
        size: 5,
        content: <LmsFormGenerator myForm={myForm} isLoading={isLoading} skipActions/>,
      },
      {
        size: 11,
        content: <LmsFormGenerator myForm={myForm1} isLoading={isLoading} skipActions/>,
      }
    ],
    [
      {
        size: 16,
        content: <React.Fragment>
          <LmsTable skipFilter title={"Borrower"} skipClick/>
          <LmsTable skipFilter title={"Guarantor"} skipClick/>
          <LmsTable skipFilter title={"Property"} skipClick/>
          <div className="lms-form-generator-submit-container">
            <Button icon={GlobalConstants.Icons.SAVE} basic content="Save" onClick={() => handleSave()}/>
            <Button icon={GlobalConstants.Icons.SAVE} basic content="Approve" onClick={() => handleApprove()}/>
            <Button icon={GlobalConstants.Icons.CLOSE} basic content={"Close"} onClick={() => useFormInstance?.handleClose()}/>
          </div>
        </React.Fragment>
      },
    ]
  ];

  return <BCDashboard DashboardLayout={LMSLoansLayout} isGreaterThanMobile={getIsGreaterThanTablet()}/>;
};

const EditDashBoard = ({ id }) => {
  return <React.Fragment>
    <EditForm id={id}/>
  </React.Fragment>;
};

const LmsNewMenuLoanApplications = ({ params = {}, history }) => {
  const { isMainPage, isEdit, isActionAllowed, id } = useParseRouteActions(params);

  if (!isActionAllowed) {
    history.goBack();
  }

  return (<React.Fragment>
    {isMainPage && <MainTable/>}
    {isEdit && <EditDashBoard id={id}/>}
  </React.Fragment>);
};

export default LmsNewMenuLoanApplications;